

// Validação Login
export function validarLogin(login) {
  if (!login) return false;

  return true;
}


// Validação senha
export function validarSenha(senha) {
  if (!senha) return false;

  return true;
}

// validar se campos obrigatórios foram preenchidos
export function validarCamposObrigatorios(campos) {
  for (const [chave, valor] of Object.entries(campos)) {
    if (!valor || valor.toString().trim() === '') {
      return { valido: false, campo: chave };
    }
  }
  return { valido: true };
}
